
$(document).ready(function(){
	
	$("#sidebar a").on('click', function(e){
		show_loading();
	});

	
	$("#sidebar")
	  .swipeDetector()
	  .on("swipeLeft.sd", function(event) {
	    if($('body').hasClass('sidebar-open'))
	    	$('body').removeClass('sidebar-open');
	  });
	
	$("#sidebar-swipe-opener")
	  .swipeDetector()
	  .on("swipeRight.sd", function(event) {
	    if( ! $('body').hasClass('sidebar-open') )
	    	$('body').addClass('sidebar-open');
	  });
});